module.exports = __webpack_public_path__ + "02794382fa9968da642a7e0f461d6bf0.svg";